import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import Money from "src/common/components/money";
import { useTranslation } from "src/hooks/translation";
import selectionsStore from "src/stores/selections";

interface IProps {
	stake: number;
}

const BetDetailsStakeWithoutTax = ({ stake }: IProps) => {
	const t = useTranslation();
	const { selections } = useRecoilValue(selectionsStore);

	const isOnlyRacingEvents = useMemo(
		() => selections.every(selection => selection.event.isRacingEvent),
		[selections]
	);

	if (!isOnlyRacingEvents) return null;

	return (
		<div className="B-betslip-bet-details-info-row">
			<p className="B-info-row-title">{t("Stake:")}</p>
			<p className="B-info-row-number">
				<Money amount={stake} />
			</p>
		</div>
	);
};

export default BetDetailsStakeWithoutTax;
